import { reduce, isArray } from 'lodash-es';
import Vue from 'vue';

/* MUTATIONS */
function getMutationFunction(name) {
  return (state, payload) => {
    Vue.set(state, name, payload);
  };
}

export const makeMutations = (name) => {
  if (isArray(name)) {
    return reduce(
      name,
      (result, mutationName) => {
        result[mutationName] = getMutationFunction(mutationName);
        return result;
      },
      {},
    );
  }

  return { [name]: getMutationFunction(name) };
};
